import axios from 'axios';
import { apiUrl } from '../../appolloConfig';
import { AUTH_TOKEN } from '../../helpers/user/authorization';
import {
  CreateLyceeThenClasseTypes,
  CreateRespTypes
} from '../../types/lycee/lycee.def';
import { capture } from '../../services/sentry/capture';
import AxiosError from '../../helpers/errors/axios.error';

export const createLyceeThenClasse = (
  payload: CreateLyceeThenClasseTypes
): Promise<CreateRespTypes> =>
  axios({
    method: 'POST',
    url: apiUrl + '/lycees/createLyceeAndClasse',
    headers: {
      Authorization: AUTH_TOKEN
    },
    data: payload
  })
    .then(resp => {
      return {
        success: true,
        message:
          'Votre classe et lycée ont bien été crées. Si la page ne se recharge pas automatiquement, veuillez cliquer sur le bouton "Actualiser" de votre navigateur',
        data: resp.data
      };
    })
    .catch(error => {
      const axiosErr = new AxiosError('Create classe and lycee ', error);
      capture(axiosErr);
      throw axiosErr;
    });
